export default ['LocaleService', function (LocaleService) {
    function link(scope, el, attrs, ngModelCtrl) {
        var symbol = LocaleService.getLocaleInfo().currency.symbol;

        ngModelCtrl.$parsers.push(function (value) {
            value = value.trim();
            if (value[0] === symbol) {
                return value.slice(1);
            }
            if (value[value.length - 1] === symbol) {
                return value.substring(0, value.length - 1);
            }
            return value;
        });
    }

    return {
        require: 'ngModel',
        restrict: 'A',
        link: link
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/common/directives/Money.js
// module id = 851
// module chunks = 0